import React from "react";

import { IconNames } from "@blueprintjs/icons";
import IconView from "common/views/icon/Icon.view";
import { Fragment } from "core/components/FragmentProvider";
import Course from "panels/catalog/entities/Course";
import ProgramLabels from "panels/catalog/Program.labels";


interface ITrackProductProps {
	course: Course;
	required?: boolean;
}

export const requiredIndicator: Fragment<ITrackProductProps> = {
	name: "Required Indicator",
	enabled: ({required}) => required,
	component: () => (
		<IconView icon={IconNames.TICK_CIRCLE} viewKey="required.icon">
			<ProgramLabels.Labels.TrackProductRequired />
		</IconView>
	)
};



// WEBPACK FOOTER //
// ./src/panels/catalog/fragments/trackProduct/displayFragments.tsx